export default __webpack_public_path__ + "static/media/fantasque_sans_monoregular.92ee7bbb.txt";